import { useState } from 'react';
import { Drawer as AntDDrawer } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors } from '../../styles/colors/';
import DrawerContent from './DrawerContent';
import DrawerTabs from './DrawerTabs';

function useDrawerState(initialValue = false) {
  const [isDrawerVisible, setIsDrawerVisible] = useState(initialValue);

  function openDrawer() {
    setIsDrawerVisible(true);
  }

  function closeDrawer() {
    setIsDrawerVisible(false);
  }

  return [isDrawerVisible, { isVisible: isDrawerVisible, open: openDrawer, close: closeDrawer }];
}

const backgroundColor = (props) => {
  if (props.backgroundColor) return props.backgroundColor;

  return colors.neutral[1];
};

const Drawer = styled(AntDDrawer)`
  .ant-drawer-content-wrapper {
    max-width: 100%;
  }

  .ant-drawer-body {
    padding: 0;
    height: 100%;
    background-color: ${backgroundColor};
    display: flex;
    flex-direction: column;
  }
`;

Drawer.defaultProps = {
  visible: false,
  width: 800,
  placement: 'right',
  closable: false,
};

Drawer.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  closable: PropTypes.bool,
  width: PropTypes.number,
  backgroundColor: PropTypes.string,
  placement: PropTypes.string,
};

Drawer.DEFAULT_SIZE = 378;

export { Drawer, DrawerContent, DrawerTabs, useDrawerState };
